import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyEasyOutIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.52 12.311C9.664 12.129 9.664 11.872 9.52 11.69L2.48 2.811C2.22 2.483 2.454 2 2.872 2H11.423C11.688 2 11.943 2.105 12.13 2.293L21.484 11.647C21.679 11.842 21.679 12.159 21.484 12.354L12.13 21.708C11.942 21.896 11.688 22.001 11.423 22.001H2.871C2.453 22.001 2.219 21.518 2.479 21.19L9.519 12.311H9.52Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyEasyOutIcon.displayName = 'TimeDkeyEasyOutIcon';
